import { render, staticRenderFns } from "./IconArrowChevronUp.vue?vue&type=template&id=66833b4e"
import script from "./IconArrowChevronUp.vue?vue&type=script&lang=js"
export * from "./IconArrowChevronUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports